import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacingTop: var(--sectionSpacing);
  --sectionSpacingBottom: var(--sectionSpacing);

  position: relative;
  scroll-margin: calc(var(--headerHeight, 0px), var(--contentsNavHeight, 0px)) 0 0;

  &[data-padding-thickness='small'] {
    --sectionSpacing: ${fluid(21, 42)};
  }

  &[data-padding-thickness='large'] {
    --sectionSpacing: ${fluid(36, 72)};
  }

  &[data-allow-scroll-margin='true'] {
    overflow: clip;
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
    }
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingBottom: 0;
    }
  }

  &[data-padding-thickness='none'],
  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
      --sectionSpacingBottom: 0;
    }
  }

  /* Negative margin bottom to force overlap */
  &[data-overlap-bottom='true'] {
    margin-bottom: calc(var(--sectionSpacingBottom) * -1);
  }
`;
const Inner = styled.div `
  color: var(--fgColor);
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  /* Don't apply background color for white backgrounds */
  ${Container} & {
    background: var(--bgColor);
  }
`;
const SiteWide = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    SiteWide,
};
export default SectionWrapperStyles;
